module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Mary-Queen-of-Scots.27d6962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Mary-Queen-of-Scots.jpg
// module id = hvRs
// module chunks = 0